module.exports = __webpack_public_path__ + "img/d3.d5a34bbe.png";